module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"language":"Language","save":"Save","settingsChanged":"Settings changed"}}')
  delete Component.options._Ctor
}
